export const BUSINESS_TYPES = [
  {
    label: "개인사업자",
    value: "개인사업자",
  },
  {
    label: "법인사업자",
    value: "법인사업자",
  },
  {
    label: "기타세무상담",
    value: "기타세무상담",
  },
];

export const CONSULTING_TYPES = [
  {
    label: "상담신청",
    value: "상담신청",
  },
  {
    label: "무료체험",
    value: "무료체험",
  },
];

export const ANSWERED_STATUS = [
  {
    label: "답변완료",
    value: "답변완료",
    color: 'color-green-100'
  },
  {
    label: "진행중",
    value: "진행중",
    color: 'color-orange-100'
  },
  {
    label: "상담취소",
    value: "상담취소",
    color: 'color-red-100'
  },
  {
    label: "대기중",
    value: "대기중",
    color: 'color-purple-100'
  },
];
